import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from './Function';
import { Placeholder,Tab,Tabs,Table,Button,Spinner } from 'react-bootstrap';
const ResearchCorner = ( {pageData} ) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[suIds, setSuIds] = useState('');
    const[Faculty,setFaculty]=useState([]);
    const[jLoadMore, setjLoadMore] = useState(true);
    const[jRows, setjRows] = useState(0);
    const[jLoading, setJLoading] = useState(true);    
    const[Journals,setJournals]=useState([]);
    const[cLoadMore, setcLoadMore] = useState(true);
    const[cRows, setcRows] = useState(0);
    const[cLoading, setCLoading] = useState(true);
    const[Conferences,setConferences]=useState([]);
    useEffect(()=>
    {
        const FacultyByTypeAndDepartment = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"faculty/byUserTypeAndDepartment/1/"+pageData.sp_sd_id);
                const result = await response.json();
                setFaculty(result);
                const suIds = result.map(item => item.su_id).join(',');
                console.info('Faculties Ids : ', suIds);
                setSuIds(suIds);
                await DepartmentJournals(suIds);
                await DepartmentConferences(suIds);               
                if( global.config.IsPrint === true ) { console.info('FacultyByTypeAndDepartment : Result',result); }

            } catch (error) 
            {
                console.error('FacultyByTypeAndDepartment : Error', error.message);
            }
        };               
        FacultyByTypeAndDepartment();
        // eslint-disable-next-line react-hooks/exhaustive-deps     
    },[pageData])
    function stripTags(html) {
        return html.replace(/<\/?[^>]+(>|$)/g, "");
    }
    const DepartmentJournals = async (suIds) => 
    {
        try 
        {
            const response = await fetch(global.config.API_URL+"journal/list/"+suIds+"/"+jRows+"/30");
            const result = await response.json();
            if (result.length > 0) 
            {
                setJournals(prevResults => jRows === 0 ? result : [...prevResults, ...result]);
                setjRows(jRows + 30);             
                setjLoadMore(true);
            } 
            else 
            {
                setjLoadMore(false);
            }           
            if( global.config.IsPrint === true ) { console.info('DepartmentJournals : Result',result); }
        } catch (error) 
        {
            console.error('DepartmentJournals : Error', error.message);
        }
        finally 
        {
            setJLoading(false);
        }
    };
    const DepartmentConferences = async (suIds) => 
    {
        try 
        {
            const response = await fetch(global.config.API_URL+"conference/list/"+suIds+"/"+cRows+"/30");
            const result = await response.json();
            if (result.length > 0) 
            {
                setConferences(prevResults => cRows === 0 ? result : [...prevResults, ...result]);
                setcRows(cRows + 30);             
                setcLoadMore(true);
            } 
            else 
            {
                setcLoadMore(false);
            }
            if( global.config.IsPrint === true ) { console.info('DepartmentConferences : Result',result); }
        } catch (error) 
        {
            console.error('DepartmentConferences : Error', error.message);
        }
        finally 
        {
            setCLoading(false);
        }
    };    
    return (
        <Tabs defaultActiveKey="0" fill>
            <Tab eventKey={0} title={appLanguage === 'hi' ? "पत्रिकाएँ" : "Journals"}>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                    <thead>
                        <tr>
                            <th className="w-75">{t('Title')}</th>
                            <th>{t('FacultyName')}</th>
                        </tr>
                    </thead>
                    {jLoading ? (
                    <tbody>
                    {[...Array(10)].map((_,index) => (
                        <tr key={index}>
                            <td><Placeholder xs={10} bg="success" /></td>
                            <td className="table-success"><Placeholder xs={10} bg="success" /></td>                                    
                        </tr>
                    ))}
                    </tbody>
                    ) : (
                    <tbody>
                    {Journals.map((sj, index) => {
                        const supervisor = Faculty.find(su => su.su_id === sj.sj_su_id);
                        return (
                            <tr key={index}>
                                <td className='text-start'>
                                    <span className="me-1">{(sj.sj_authors_hi || sj.sj_authors) && (appLanguage === 'hi' ? sj.sj_authors_hi || sj.sj_authors : sj.sj_authors) + ','}</span>
                                    <span className="fw-bold me-1">{(sj.sj_name_hi || sj.sj_name) && (appLanguage === 'hi' ? sj.sj_name_hi || sj.sj_name : sj.sj_name) + ','}</span>
                                    <span className="me-1">{(sj.sj_description_hi || sj.sj_description) && stripTags(appLanguage === 'hi' ? sj.sj_description_hi || sj.sj_description : sj.sj_description) + ','}</span>
                                    <span className="me-1">{sj.sj_volume && sj.sj_volume +','}</span>
                                    <span className="me-1">{sj.sj_page_no && sj.sj_page_no + ','}</span>
                                    <span className="me-1">{sj.sj_date && formatDate(sj.sj_date)}</span> 
                                </td>
                                <td className="table-success fw-bold">
                                    {supervisor ? appLanguage === 'hi' ? supervisor.su_name_hi || supervisor.su_name : supervisor.su_name : "--"}
                                </td>                                    
                            </tr>
                        );
                    })}
                    
                    </tbody>
                    )}
                </Table>
                {jLoadMore &&
                <div className='text-center p-3'>
                    <Button className='btn btn-info mt-3' onClick={() => DepartmentJournals(suIds)} disabled={jLoading}>
                        {jLoading ? (
                        <React.Fragment>
                            <Spinner animation="grow" variant="light" size="sm" />
                            <Spinner animation="grow" variant="danger" size="sm" />
                            <span className='ms-2'>{t('PleaseWait')}</span>
                        </React.Fragment>
                        ) : t('LoadMore')}
                    </Button>
                </div>}
            </Tab>
            <Tab eventKey={1} title={appLanguage === 'hi' ? "सम्मेलन" : "Conferences"}>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                    <thead>
                        <tr>
                            <th className="w-75">{t('Title')}</th>
                            <th>{t('FacultyName')}</th>
                        </tr>
                    </thead>
                    {cLoading ? (
                    <tbody>
                    {[...Array(10)].map((_,index) => (
                        <tr key={index}>
                            <td><Placeholder xs={10} bg="success" /></td>
                            <td className="table-success"><Placeholder xs={10} bg="success" /></td>                                    
                        </tr>
                    ))}
                    </tbody>
                    ) : (
                    <tbody>
                    {Conferences.map((sc, index) => {
                        const supervisor = Faculty.find(su => su.su_id === sc.sc_su_id);
                        return (
                            <tr key={index}>
                                <td className='text-start'>
                                    <span className="me-1">{(sc.sc_author_hi || sc.sc_author) && (appLanguage === 'hi' ? sc.sc_author_hi || sc.sc_author : sc.sc_author) + ','}</span>
                                    <span className="fw-bold me-1">{(sc.sc_name_hi || sc.sc_name) && (appLanguage === 'hi' ? sc.sc_name_hi || sc.sc_name : sc.sc_name) + ','}</span>
                                    <span className="me-1">{(sc.sc_description_hi || sc.sc_description) && stripTags( appLanguage === 'hi' ? sc.sc_description_hi || sc.sc_description : sc.sc_description ) + ',' }</span>
                                    <span className="me-1">{(sc.sc_publisher_hi || sc.sc_publisher) && (appLanguage === 'hi' ? sc.sc_publisher_hi || sc.sc_publisher : sc.sc_publisher) + ','}</span>
                                    <span className="me-1">{sc.sc_pages && sc.sc_pages +','}</span>
                                    <span className="me-1">{(sc.sc_venue_hi || sc.sc_venue) && (appLanguage === 'hi' ? sc.sc_venue_hi || sc.sc_venue : sc.sc_venue) + ','}</span>
                                    <span className="me-1">{sc.sc_date && formatDate(sc.sc_date)}</span>
                                </td>
                                <td className="table-success fw-bold">
                                    {supervisor ? appLanguage === 'hi' ? supervisor.su_name_hi || supervisor.su_name : supervisor.su_name : "--"}
                                </td>                                    
                            </tr>
                        );
                    })}                            
                    </tbody>
                    )}
                </Table>
                {cLoadMore &&
                <div className='text-center p-3'>
                    <Button className='btn btn-info mt-3' onClick={() => DepartmentConferences(suIds)} disabled={cLoading}>
                        {cLoading ? (
                        <React.Fragment>
                            <Spinner animation="grow" variant="light" size="sm" />
                            <Spinner animation="grow" variant="danger" size="sm" />
                            <span className='ms-2'>{t('PleaseWait')}</span>
                        </React.Fragment>
                        ) : t('LoadMore')}
                    </Button>
                </div>}
            </Tab>
        </Tabs>
    );
}

export default ResearchCorner;